export function Percent(props) {
    return (props.amount * 100 || 0).toFixed(3) + "%";
}